export default __webpack_public_path__ + "static/media/people-icon.b5561d4b.svg";